export const INSTAGRAM_PHOTO_LIST_REQUEST = "INSTAGRAM_PHOTO_LIST_REQUEST";
export const INSTAGRAM_PHOTO_LIST_SUCCESS = "INSTAGRAM_PHOTO_LIST_SUCCESS";
export const INSTAGRAM_PHOTO_LIST_FAIL = "INSTAGRAM_PHOTO_LIST_FAIL";